import steps from '../../survey/stepsV2';

export function initOneTrustTracking() {
  const acceptHandler = (e) => {
    if (
      e.target?.id === 'onetrust-accept-btn-handler'
      || e.target?.id === 'accept-recommended-btn-handler'
    ) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_accept',
        },
      });
    }
  };

  const settingsHandler = (e) => {
    if (
      e.target?.id === 'onetrust-pc-btn-handler'
      || e.target?.classList?.contains('ot-floating-button__open')
    ) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_settings',
        },
      });
    }
  };

  const rejectHandler = (e) => {
    if (e.target?.classList?.contains('ot-pc-refuse-all-handler')) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_reject',
        },
      });
    }
  };

  window.addEventListener('OneTrustGroupsUpdated', () => {
    const groups = window.OnetrustActiveGroups || '';

    steps.analytics.send({
      event: {
        event: 'quiz_funnel',
        quiz_action: 'onetrust_preferences',
        quiz_answer: groups,
      },
    });
  });

  document.addEventListener('click', (e) => {
    acceptHandler(e);
    settingsHandler(e);
    rejectHandler(e);
  });
}
